module.exports = __webpack_public_path__ + "img/运维台.7e61ca72.png";